interface DefaultErrorDescriptionProps {
    errorDescription: string;
}

function DefaultErrorDescription({ errorDescription }: DefaultErrorDescriptionProps) {
    return <p className="text-foreground text-base leading-relaxed">{errorDescription}</p>;
}

export default DefaultErrorDescription;
